export default __webpack_public_path__ + "static/media/tiktok.8b19af26.png";